module.exports = __webpack_public_path__ + "static/media/iamthatiam4.9d6c5af6.jpg";